import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardAreaComponent } from './card-area.component';

@NgModule({
  declarations: [CardAreaComponent],
  imports: [CommonModule],
  exports: [CardAreaComponent],
})
export class CardAreaModule {}
